/**
 * Destino depois do login ("voltar para").
 *
 * Quem escaneia o QR sem sessão passa pelo login e precisa voltar à tela de confirmação.
 * O destino viaja pela URL e pelo login Microsoft, então só pode ser um caminho interno do
 * próprio sistema: qualquer outra coisa viraria redirecionamento para site externo.
 */

/** Telas que não fazem sentido como destino: voltariam para o próprio login. */
const BLOCKED_PREFIXES = ['/entrar', '/auth/callback', '/api/'];

export function safeReturnPath(value: string | null | undefined): string | null {
  if (!value || value.length > 512) return null;
  // Caminho absoluto do próprio site: "/x". "//x" e "/\x" são lidos como outro domínio.
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  // Sem esquema, controle ou barra invertida em lugar nenhum.
  if ([...value].some((character) => character === '\\' || character.charCodeAt(0) < 32)) {
    return null;
  }
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(value)) return null;
  if (value === '/') return null;
  if (BLOCKED_PREFIXES.some((prefix) => value === prefix || value.startsWith(prefix))) return null;
  return value;
}
